import { FC } from 'react';

import { iconTypes } from './config';

interface IProps {
  variant:
  | 'logo'
  | 'greyLogo'
  | 'close'
  | 'user'
  | 'game'
  | 'divider'
  | 'arrowLeft'
  | 'share'
  | 'copy'
  | 'arrowRight'
  | 'search'
  | 'menu'
  | 'users' | 'sort' | 'calendar' | 'sandClock' | 'watch' | 'arrowDown' | 'cube';
}

const Icon: FC<IProps> = ({ variant }) => iconTypes[variant];

export default Icon;
